function reloadBasketCount(){
    $('.basket ').animate({opacity: '0'}, 'fast');
    setTimeout(function(){
      jQuery.ajax({
        url: '/cart.js',
        dataType: 'json'
      })
      .done(function(data){
        let cartcurrentCount = String(data.item_count);
        let cartcurrentCost = String(data.total_price);            
        let costCent = cartcurrentCost.substr(-2);
        let currentCost = cartcurrentCost.slice(0, - 2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,');                                    

        if(data.item_count > 0){
          $('span#CartCount').html(cartcurrentCount);
          $('span#cart-price').html('$'+currentCost+'.'+costCent);
          $('.basket ').animate({opacity: '1'}, 'fast');
        }else{
          $('span#CartCount').empty();
          $('span#cart-price').empty ();
          $('.basket ').animate({opacity: '1'}, 'fast');          
        }

      });          
    }, 500);   
}

function quantityCartItems(qbox){
  $(".qntyMinus").click('on', function(){
	if ($( this ).parent(qbox).find(".qntyValue").val() > 1) {
     	$( this ).parent(qbox).find(".qntyValue").val(+$( this ).parent(qbox).find(".qntyValue").val() - 1);
      	var mlTpl = $( this ).parent(qbox).attr("data-price");
      	var costMltpl = $( this ).parent(qbox).find(".qntyValue").val();
      	var costResult = mlTpl * costMltpl;
       	var costResultPrice = '$ '+String(costResult).slice(0, - 2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,')+'.'+String(costResult).substr(-2);
      	$( this ).parent(qbox).closest(".trItemInCartRight").find(".rcart-cost").attr("data-cost", costResult).find("span").html(costResultPrice);
      	var productId = $( this ).parent(qbox).find(".qntyValue").attr("data-id");
		let queryUpdate = {'id': productId,'quantity': costMltpl};                                
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(queryUpdate)
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });   
      	summCost();        
        reloadBasketCount();     

      	
   	}    
  });
  $(".qntyPlus").click('on', function(){
   		$( this ).parent(qbox).find(".qntyValue").val(+$( this ).parent(qbox).find(".qntyValue").val() + 1);
      	var mlTpl = $( this ).parent(qbox).attr("data-price");
      	var costMltpl = $( this ).parent(qbox).find(".qntyValue").val();
      	var costResult = mlTpl*costMltpl;
       	var costResultPrice = '$ '+String(costResult).slice(0, - 2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,')+'.'+String(costResult).substr(-2);
      	$( this ).parent(qbox).closest(".trItemInCartRight").find(".rcart-cost").attr("data-cost", costResult).find("span").html(costResultPrice);
      	var productId = $( this ).parent(qbox).find(".qntyValue").attr("data-id");
		let queryUpdate = {'id': productId,'quantity': costMltpl};                

    	fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(queryUpdate)
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });   
      	summCost();        
        reloadBasketCount();  
  });
}

function summCost(){
  	var summCost = 0;
  	$("div.rcart-cost").each(function(){
      	summCost += parseInt($(this).attr("data-cost"));
	});
    $(".rcart-subtotal span").html('$ '+String(summCost).slice(0, - 2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,')+'.'+String(summCost).substr(-2));
}

function removeItem(){
  
  $(".rcart-rmvbutton").click('on', function(){
    
     if(confirm('Can You remove it?')){
      	var productId = $( this ).closest(".trItemInCartRight").find(".qntyValue").attr("data-id");
		let queryUpdate = {'id': productId,'quantity': 0};                

    	fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(queryUpdate)
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
       	$( this ).closest(".trItemInCartRight").remove();
       	reloadBasketCount();
       	summCost(); 
     }
  });  
  
}

$(document).ready(function(){
  reloadBasketCount();
});



function cartPreloader(box, load){
  let loadImg = '//elminorthamerica.com/cdn/shop/t/23/assets/loader.gif?v=146335725397836307021748486630';
  $(box).append('<div class="loaderwrap"><div><span><img src="'+loadImg+'"/><span></div></div>').fadeIn('100');
  setTimeout(function(){  
    $(load).load('on', function(){
     $('.loaderwrap').fadeOut();
    });
  }, 1800);
}

function modalMessage(content){  
  $('.cartMessageText').html(content);
  $('.cartMessager').fadeIn('fast');
  setTimeout(function(){ 
  	$('.cartMessager').fadeOut('fast');
    $('.cartMessageText').html('');
  }, 1000);
}

function reloadBasketRight(put, putcost){
  cartPreloader('.cart-right-toggle', '#cart-content');
  $('.emptyCart').remove();
  $(put).fadeOut('fast');
  $(putcost).fadeOut('fast');
  setTimeout(function(){
      jQuery.ajax({
        url: '/cart.js',
        dataType: 'json'
      })
      .done(function(data){
        if(data.items.length > 0){
          let itemsToCart = '';
          $.each(data.items, function(key, item) {
            itemsToCart +=               
              '<tr class="trItemInCartRight">'
              +'<td>'
              +'<a class="rcart-prod-link" href="'+item.url+'">'
              +'<img src="'+item.image+'"alt="'+item.title+'" />'
              +'</a>'
              +'</td>'
              +'<td>'
              +'<a class="rcart-prod-link" href="">'
              +'<div class="rcart-title">'+item.title+'</div>'
              +'</a>'
              +'</td>'
              +'<td>'
              +'<div class="rcart-price">Price: <br/><span>$ '+String(item.price).slice(0, - 2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,')+'.'+String(item.price).substr(-2)+'</span></div>'
              +'</td>'
              +'<td>'
              +'<div class="quantCartBox quantBox" data-price="'+item.price+'" data-cost="'+item.line_price+'">'
              +'<span class="qntyMinus" data-quantity-change="-1"><div class="minus-sym"></div></span>										 '
              +'<input class="quantity qntyValue" type="number" name="updates[]" data-id="'+item.variant_id+'" id="updates_'+item.product_id+'" value="'+item.quantity+'" min="1" step="1">'
              +'<span class="qntyPlus" data-quantity-change="1"><div class="plus-sym"></div><div class="plus-sym2"></div></span>' 
              +'</div>'
              +'</td>'
              +'<td>'
              +'<div class="rcart-cost" data-cost="'+item.line_price+'">Cost: <br/><span>$ '+String(item.line_price).slice(0, - 2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,')+'.'+String(item.line_price).substr(-2)+'</span></div>'
              +'</td>'
              +'<td>'
              +'<a class="rcart-rmvbutton"></a>'
              +'</td>'
              +'</tr>'                
            ;
          }); 
          
          let totalCartCost = 'Subtotal: <span>$ '+String(data.total_price).slice(0, - 2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,')+'.'+String(data.total_price).substr(-2)+'</span>';
          let subtotalCost = '';
          
          $(put).html(itemsToCart).fadeIn('fast');
          $(putcost).html(totalCartCost).fadeIn('fast');
          quantityCartItems('.quantCartBox');
          removeItem();
          $('.rcart-checkout').fadeIn('fast');
          
        }else{
          	$('.rcart-checkout').fadeOut('fast');
          	 $('#cart-content').append(
               	 '<div class="emptyCart">'
                +'<h2 class="gamma">It appears that your cart is currently empty!</h2>'
                +'<h3 class="delta">You can continue browsing <a href="/collections/all">here</a>.</h3>'
    			+'</div>');
        }
      });
    }, 500);    
}


$(document).ready(function() {
    $("#cartheadbutton").click(function(){
      $(".rcart-cover").fadeIn("fast");
      $(".cart-right-toggle").fadeIn("fast").addClass("rcart-vision");  
      reloadBasketRight('.tbodyCartRight', '.rcart-subtotal');
    });    
})

$(document).ready(function() {
    $("#clothe-rcart").click(function(){
        $(".rcart-cover").fadeOut("fast"); 
        $(".cart-right-toggle").fadeOut("fast").removeClass("rcart-vision");
    });    
})

$(document).mouseup(function (e) {
    var container = $(".cart-right-toggle");
    if (container.has(e.target).length === 0){
        $(".rcart-cover").fadeOut("fast"); 
        $(".cart-right-toggle").fadeOut("fast").removeClass("rcart-vision");
    }
});


//Cart Clear function
//===================================

$(document).ready(function(){
  $('button#clear-cart').on('click', function(){
    if(confirm('Realy?')){
      jQuery.post('/cart/clear.js');
      
      jQuery.ajax({
        url: '/cart.js',
        dataType: 'json'
      })
      .done(function(data){
        console.log(data);
        reloadBasketRight('.tbodyCartRight', '.rcart-subtotal');
        reloadBasketCount();
      });      
      
      
    }else{
    }
  });
});

setTimeout(function(){
  if ($('#sg-pro-access-wrapper').length){
    $('#sg-pro-access-wrapper').load('on', function(){
      $(document).ready(function() {
        $('#addtocartajax').on('click', function(addtoCartClick){
          $(this).bind('click',function(){return false;});
          $('.bindAddButton').fadeIn('100');
          $('.bindAddButton img').fadeIn('200');

          var productId = $('form#add-to-cart').attr('data-productid');
          var productQty = $('form#add-to-cart').find('.pp-quantbox').find('.qnty-num').val();        
          let accessProduct = {'items': [{'id': productId,'quantity': productQty}]};
          $('input.sg-pro-access-checkbox:checked').each(function (index, element) {
            accessProduct['items'].push({
                  'id': $(element).parents( ".sg-pro-access-product" ).find(".spice_select_variant_id").val(),
                  'quantity': $(element).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val()
              });          
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(accessProduct)
          })
          .then(response => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });   

          reloadBasketCount();
          setTimeout(function(){
            $('.bindAddButton img').fadeOut('100');
            $('.bindAddButton').append('<span>Successfuly added to Cart</span>').fadeIn('100');
          }, 1800);
          setTimeout(function(){
            $('.bindAddButton').fadeOut('100');
            $('.bindAddButton span').remove();
            $('#addtocartajax').bind('click',function(){return true;});
            $('input.sg-pro-access-checkbox:checked').prop('checked', false);
            $('.spice_select_variant_quantity').val('1');
            $('.sg-pro-access-product').removeAttr('style');
            $( ".pp-quantacc" ).hide();
          }, 3000);

        });
      });
    });
  } else {
	$(document).ready(function() {
        $('#addtocartajax').on('click', function(addtoCartClick){
          $(this).bind('click',function(){return false;});
          $('.bindAddButton').fadeIn('100');
          $('.bindAddButton img').fadeIn('200');

          var productId = $('form#add-to-cart').attr('data-productid');
          var productQty = $('form#add-to-cart').find('.pp-quantbox').find('.qnty-num').val();        
          let accessProduct = {'items': [{'id': productId,'quantity': productQty}]};
          $('input.sg-pro-access-checkbox:checked').each(function (index, element) {
            accessProduct['items'].push({
                  'id': $(element).parents( ".sg-pro-access-product" ).find(".spice_select_variant_id").val(),
                  'quantity': $(element).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val()
              });          
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(accessProduct)
          })
          .then(response => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });   

          reloadBasketCount();
          setTimeout(function(){
            $('.bindAddButton img').fadeOut('100');
            $('.bindAddButton').append('<span>Successfuly added to Cart</span>').fadeIn('100');
          }, 1800);
          setTimeout(function(){
            $('.bindAddButton').fadeOut('100');
            $('.bindAddButton span').remove();
            $('#addtocartajax').bind('click',function(){return true;});
            $('input.sg-pro-access-checkbox:checked').prop('checked', false);
            $('.spice_select_variant_quantity').val('1');
            $('.sg-pro-access-product').removeAttr('style');
            $( ".pp-quantacc" ).hide();
          }, 3000);

        });
      });    
  }
}, 3000); 


